<template>
  <div class="basket">
    <div v-if="basket">
      <div class="basket-table-title d-none d-lg-table" v-if="basket.total_quantity > 0">
        <div class="table-cell product-wrap">
          <h5>Product</h5>
        </div>
        <div class="table-cell quantity">
          <h5>Qty</h5>
        </div>
        <div class="table-cell">
          <h5>Item Price</h5>
        </div>
        <div class="table-cell price">
          <h5>Total</h5>
        </div>
      </div>

      <div class="basket-table" v-for="item in basket.items" :key="item.id">
        <div class="table-row">
          <div class="table-cell product-wrap">
            <div class="row">
              <div class="col-16 col-lg-5 w-auto">
                <img :src="item.primary_image_url" :alt="item.name + ' Image'" width="100">
              </div>
              <div class="col-16 col-lg-7 w-auto contourField">
                <p class="product-name">{{ item.name }}</p>
                <p class="product-options text-uppercase">{{ item.locked ? item.comment : item.options_description }}<br>{{ item.addon_item_comment }}</p>
                <p v-if="item.is_used"><b>Pre-Loved</b></p>
              </div>
            </div>
          </div>
          <div class="table-cell quantity">
            <span class="mob-label d-block">
              Quantity:
            </span>
            {{item.quantity}}
          </div>
          <div class="table-cell d-none d-lg-table-cell">
              £{{ item.unit_price_inc_vat|money }}
          </div>
          <div class="table-cell price">
            <div class="mob-label">
              Total:
            </div>
              £{{ item.line_undiscounted_total|money }}
          </div>
        </div>
      </div>

      <div v-if="basket.total_quantity === 0" class="alert alert-warning">
        You have no items in your basket.
      </div>
    </div>

    <div v-if="loading || !basket" class="d-flex align-items-center justify-content-center mt-5">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    };
  },

  props: {
    basket: {
      type: Object,
    },
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    //
  },
};
</script>
